import { $WINDOW, TABLET_WIDTH } from "../lib/constants";

export const historyFunctions = () => {
  const $LIST_ITEMS = document.querySelectorAll(".js-about-list-item");
  const MIDDLE_OF_THE_SCREEN = document.scrollingElement.clientHeight / 2;
  const $PROGRESS_BAR = $(".js-about-list-progress-bar");

  const WATCHED_CLASS = "about__list-item--watched";

  if ($LIST_ITEMS.length) {
    const addWatchedHeightToProgressBar = () => {
      const { y } = $PROGRESS_BAR[0].getBoundingClientRect();

      if (y < MIDDLE_OF_THE_SCREEN) {
        if (MIDDLE_OF_THE_SCREEN - y > parseInt($PROGRESS_BAR.css("height"))) {
          $PROGRESS_BAR.css("height", MIDDLE_OF_THE_SCREEN - y);
        }

        setTimeout(() => {
          $PROGRESS_BAR.css("transition-duration", ".1s");
        }, 300);
      }
    };

    (function setMaxHeightForProgressBar() {
      const lastItemHeight = $(
        $LIST_ITEMS[$LIST_ITEMS.length - 1]
      ).outerHeight();
      if ($WINDOW.width() > TABLET_WIDTH) {
        $PROGRESS_BAR.css(
          "max-height",
          `calc(100% - ${lastItemHeight}px + 10px`
        );
      } else {
        $PROGRESS_BAR.css("max-height", `calc(100% - ${lastItemHeight}px`);
      }
    })();

    (function checkProgressBarHeight() {
      addWatchedHeightToProgressBar();
    })();

    const addWatchedClassToListItemByCenterViewAcross = () => {
      $.each($LIST_ITEMS, function (_, el) {
        const $el = $(el);
        const { y } = el.getBoundingClientRect();

        if (y < MIDDLE_OF_THE_SCREEN && !$el.hasClass(WATCHED_CLASS)) {
          $el.addClass(WATCHED_CLASS);
        }
      });
    };

    (function checkWatchedListItem() {
      addWatchedClassToListItemByCenterViewAcross();
    })();

    window.onscroll = function () {
      addWatchedClassToListItemByCenterViewAcross();
      addWatchedHeightToProgressBar();
    };
  }
};
